// Photo filenames for Iron Maidens 2004
const IRON_MAIDENS_2004_PHOTOS = [
  "im0408_31251274190_z.jpg",
  "im0409_31476922292_z.jpg",
  "im0410_30813540293_z.jpg",
  "im0411_31476922272_z.jpg",
  "im0412_31251274080_z.jpg",
  "im0413_31476922162_z.jpg",
  "im0414_31251274000_z.jpg",
  "im0415_30813540183_z.jpg",
  "im0416_30782138594_z.jpg",
  "im0417_30813540143_z.jpg",
  "im0418_31251273880_z.jpg",
  "im0419_30782138404_z.jpg",
  "im0420_31251273860_z.jpg",
  "im0422_30782138374_z.jpg",
  "im0423_31251273800_z.jpg",
  "im0425_30782138294_z.jpg",
  "im0401_31251274660_z.jpg",
  "im0402_31251274540_z.jpg",
  "im0403_31476922532_z.jpg",
  "im0404_31251274420_z.jpg",
  "im0405_30813540443_z.jpg",
  "im0406_31251274300_z.jpg",
  "im0407_30813540383_z.jpg"
];

export default IRON_MAIDENS_2004_PHOTOS;
